<mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content [innerHTML]="message | safeHtml"></div>
<div mat-dialog-actions>
  <button mat-raised-button  (click)="dialogRef.close(true)" cdkFocusInitial>{{ buttonText }}</button>
</div>
